import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

// --- BẮT ĐẦU: COMPONENT 404 (INLINE) ---
const NotFoundPage = () => {
  const [text, setText] = useState('');
  const fullText = "sudo return_to_homepage";
  useEffect(() => {
    let index = 0; let tempText = "";
    const intervalId = setInterval(() => {
      if (index < fullText.length) { tempText += fullText.charAt(index); setText(tempText); index++; } 
      else { clearInterval(intervalId); }
    }, 100);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: '#0d0d0d', color: '#33ff00', fontFamily: "'Courier New', Courier, monospace", display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden', zIndex: 99999 }}>
      <div style={{ width: '90%', maxWidth: '600px', padding: '2rem', border: '2px solid #1a8000', boxShadow: '0 0 20px rgba(51, 255, 0, 0.1)', position: 'relative', backgroundColor: '#0d0d0d' }}>
        <h1 style={{ fontSize: '2rem', marginTop: 0, textShadow: '0 0 5px #33ff00', marginBottom: '1rem' }}>Error 404: Location Not Found</h1>
        <p style={{ fontSize: '1.1rem', lineHeight: 1.5, margin: '0.5rem 0' }}>The system cannot find the path specified.</p>
        <p style={{ fontSize: '1.1rem', lineHeight: 1.5, margin: '0.5rem 0' }}>{'>'} Analyzing coordinates... <span style={{color: '#1a8000'}}>[FAILED]</span></p>
        <p style={{ fontSize: '1.1rem', lineHeight: 1.5, margin: '0.5rem 0' }}>{'>'} User: <span style={{color: 'white'}}>Guest</span></p>
        <p style={{ fontSize: '1.1rem', lineHeight: 1.5, margin: '0.5rem 0' }}>{'>'} Status: <span style={{color: 'orange'}}>Lost in Cyberspace</span></p>
        <div style={{ display: 'flex', alignItems: 'center', marginTop: '1rem' }}><span style={{ color: '#fff', marginRight: '10px' }}>root@tai-nguyen:~#</span><span>{text}</span><span style={{ display: 'inline-block', width: '10px', height: '1.2em', backgroundColor: '#33ff00', marginLeft: '5px', animation: 'blink 1s step-end infinite' }}></span></div>
        <Link to="/" style={{ display: 'inline-block', marginTop: '2rem', padding: '10px 20px', border: '1px solid #33ff00', color: '#33ff00', textDecoration: 'none', fontWeight: 'bold', textTransform: 'uppercase', cursor: 'pointer' }} onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#33ff00'; e.currentTarget.style.color = '#0d0d0d'; }} onMouseOut={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = '#33ff00'; }}>Execute: cd /home</Link>
      </div>
      <style>{`@keyframes blink { 0%, 100% { opacity: 1; } 50% { opacity: 0; } }`}</style>
    </div>
  );
};
// --- KẾT THÚC COMPONENT 404 ---

export default NotFoundPage;
